__turbopack_context__.v({
  "changelog-container": "styles-module__u3F9aq__changelog-container",
});
